<template>
    <div>
        <div class="Panel" v-if="hasUnknown">
            <div class="Panel__heading">Unknown {{ name }}</div>
            <div class="Panel__body">
                <div class="TableResponsive">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th style="width: 15%">Code</th>
                            <th>Name</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in unknownItems">
                            <td>{{ item.code }}</td>
                            <td class="Table__cell--form-field">
                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="item.name"
                                       @keyup.enter="updateUnknownItem(item, index)"
                                >
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   @click.prevent="deleteUnknownItem(item.id)"
                                >
                                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success"
                                   @click.prevent="updateUnknownItem(item, index)"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="Panel">
            <div class="Panel__heading">{{ name }}</div>
            <div class="Panel__body">
                <div class="TableResponsive">
                    <table class="Table Table--striped Table--admin">
                        <thead>
                        <tr>
                            <th style="width: 15%">Code</th>
                            <th>Name</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in sortedKnownItems">
                            <td>{{ item.code }}</td>
                            <td class="Table__cell--form-field">
                                <input type="text"
                                       class="Form__text"
                                       v-if="isBeingEdited(item.id)"
                                       v-model.trim="editing[item.id].name"
                                       @keyup.enter="updateKnownItem(item.id)"
                                >

                                <span v-else>{{ item.name }}</span>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   v-if="isBeingEdited(item.id)"
                                   @click.prevent="endEdit(item.id)"
                                >
                                    <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--danger"
                                   v-else
                                   @click.prevent="deleteKnownItem(item.id)"
                                >
                                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="Table__cell--control">
                                <a href="#"
                                   class="Table__control Table__control--success"
                                   @click.prevent="updateKnownItem(item.id)"
                                   v-if="isBeingEdited(item.id)"
                                >
                                    <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                </a>

                                <a href="#"
                                   class="Table__control Table__control--primary"
                                   v-else
                                   @click.prevent="editItem(item.id, item.name)"
                                >
                                    <i class="fa fa-pencil fa-fw" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                knownItems: [],
                unknownItems: [],
                editing: {},
            }
        },

        props: {
            /**
             * The name of the filter type
             */
            name: {
                type: String,
                required: true,
            },

            /**
             * The URL to submit updates to
             */
            patch: {
                type: String,
                required: true,
            },

            known: {
                required: true,
            },

            unknown: {
                required: true,
            }
        },

        mounted() {
            this.knownItems = this.known;
            this.unknownItems = this.unknown;
        },

        computed: {
            /**
             * Check to see if there are any unknown items
             * @return {boolean}
             */
            hasUnknown() {
                return ! _.isEmpty(this.unknownItems);
            },

            /**
             * Make sure the patch URL has a / on the end
             * @return {*}
             */
            patchUrl() {
                return _.endsWith(this.patch, '/') ? this.patch : this.patch + '/';
            },

            /**
             * Alphabetically sort the known items
             * @return {Array}
             */
            sortedKnownItems() {
                return _.sortBy(this.knownItems, (item) => {
                    return item.name.toLowerCase();
                });
            },
        },

        methods: {
            /**
             * Update an unknown item
             * @param item
             * @param index
             */
            updateUnknownItem(item, index) {
                this.updateItem(item, () => {
                    this.knownItems.push(this.unknownItems[index]);
                    this.unknownItems.splice(index, 1);
                })
            },

            /**
             * Update a known item
             * @param id
             */
            updateKnownItem(id) {
                this.updateItem(this.editing[id], () => {
                    _.find(this.knownItems, ['id', id]).name = this.editing[id].name;
                    this.endEdit(id);
                })
            },

            /**
             * Submit the given updated item to the server
             * @param item
             * @param callback
             */
            updateItem(item, callback) {
                if (item.name == '') return;

                this.$http.patch(this.patchUrl + item.id, {
                    name: item.name
                }).then((response) => {
                    _.pull(this.editing, item.id);

                    if (callback) {
                        callback();
                    }

                    this.$forceUpdate();
                })
            },

            /**
             * Delete an unknown item
             */
            deleteUnknownItem(id) {
                this.deleteItem(id, () => {
                    this.unknownItems = _.reject(this.unknownItems, (item) => {
                        return item.id == id;
                    });
                });
            },

            /**
             * Delete an unknown item
             */
            deleteKnownItem(id) {
                this.deleteItem(id, () => {
                    this.knownItems = _.reject(this.knownItems, (item) => {
                        return item.id == id;
                    });
                });
            },

            /**
             * Delete the given item
             * @param id
             * @param callback
             **/
            deleteItem(id, callback) {
                this.$http.delete(this.patchUrl + id).then(() => {
                    if (callback) {
                        callback();
                    }

                    this.$forceUpdate();
                })
            },

            /**
             * Flag the item with the given id as being edited
             * @param id
             * @param value
             */
            editItem(id, value) {
                _.set(this.editing, id, { id: id, originalValue: value, name: value })

                this.$forceUpdate();
            },

            /**
             * Stop an item from being edited
             * @param id
             */
            endEdit(id) {
                _.unset(this.editing, id);

                this.$forceUpdate();
            },

            /**
             * Check whether the item with the given id is being edited
             * @param id
             * @return {boolean}
             */
            isBeingEdited(id) {
                return _.has(this.editing, id)
            },
        },
    }
</script>